import './style.scss';
import psl_ui from '../../libs/psl_ui.js';
import psl_actions from '../../libs/psl_actions.js';
import template from './template.pst';
import template_card from './template_card.pst';

import {wait} from '../../libs/psl_polyfills.js';

import CONFIG from '../../CONFIG.js';

psl_ui.templates.add('big_cards',template);
psl_ui.templates.add('big_card',template_card);

class SmallCards{
	constructor(section_data){
		const {el, rpoints} = psl_ui.templates.render('big_cards');

		this._rpoints=rpoints;
		this.view=el;
		this.view.controller=this;

		this.data=section_data;

		this._rpoints.wrapper.addEventListener('pointerdown',(e)=>{
			if(!window.matchMedia('(min-width: 769px)').matches) return;
			// const target = e.target;
			// const interactive = target.closest('button, a, [data-action]');
			// if(interactive && interactive !== this._rpoints.wrapper){
			// 	return;
			// }
			this._pointer_start_x = e.clientX;
			this._scroll_start_x = this._rpoints.wrapper.scrollLeft;
			this._is_dragging = false;
			this._has_moved = false;
			this._pointer_id = e.pointerId;
			//this._rpoints.wrapper.setPointerCapture(e.pointerId);
		});

		this._rpoints.wrapper.addEventListener('pointermove',(e)=>{
			if(!window.matchMedia('(min-width: 769px)').matches || this._pointer_start_x === undefined || e.pointerId !== this._pointer_id) return;
			const delta_x = Math.abs(this._pointer_start_x - e.clientX);
			if(delta_x > 5){
				if(!this._is_dragging){
					psl_actions.break();
					this._is_dragging = true;
					this._has_moved = true;
					this._rpoints.wrapper.style.cursor = 'grabbing';
					this._rpoints.wrapper.style.userSelect = 'none';
				}
				this._rpoints.wrapper.scrollLeft = this._scroll_start_x + (this._pointer_start_x - e.clientX);
			}
		});

		this._rpoints.wrapper.addEventListener('pointerup',(e)=>{
			if(e.pointerId !== this._pointer_id) return;
			if(this._is_dragging){
				this._is_dragging = false;
				this._rpoints.wrapper.style.cursor = '';
				this._rpoints.wrapper.style.userSelect = '';
				e.preventDefault();
			}
			this._pointer_start_x = undefined;
			this._pointer_id = undefined;
			//this._rpoints.wrapper.releasePointerCapture(e.pointerId);
		});

		this._rpoints.wrapper.addEventListener('pointercancel',(e)=>{
			if(e.pointerId !== this._pointer_id) return;
			if(this._is_dragging){
				this._is_dragging = false;
				this._rpoints.wrapper.style.cursor = '';
				this._rpoints.wrapper.style.userSelect = '';
			}
			this._pointer_start_x = undefined;
			this._pointer_id = undefined;
			//this._rpoints.wrapper.releasePointerCapture(e.pointerId);
		});
	}

	on_submenu(){

	}

	async show(){
		this.view.classList.remove('hidden');
		await wait(350);
	}

	async hide(){
		this.view.classList.add('hidden');
		await wait(350);
	}

	set data(_){
		this._data=_;
		this._render();
	}

	get data(){
		return this._data;
	}

	_render(){
		this._rpoints.header.innerHTML=this._data.name||"";
		//this._rpoints.subheader.innerHTML=this._data.name||"";
		this.view.style.backgroundImage=`url("${CONFIG.backend_base_url}files/${this._data.bkg}")`;

		this._rpoints.list.innerHTMl='';

		this._data.cards.forEach(card=>{
			this._rpoints.list.appendChild(psl_ui.templates.render('big_card',card).el)
		});
	}
}

export default SmallCards;
